import { Dispatch, Action as ReduxAction } from 'redux';

import { BVScheduledTransport } from '@/modules/common/model';
import { ValidateActionMap } from '@/shared/modules/redux/model';

import API from '../../common/api';
import { TripStatus } from '../model';

export const FETCH_INFORMATIONS: string = 'FETCH_INFORMATIONS';
export const FETCH_INFORMATIONS_SUCCESS: string = 'FETCH_INFORMATIONS_SUCCESS';
export const SET_TRIP_STATUS: string = 'SET_TRIP_STATUS';
export const CLEAR_INFORMATIONS: string = 'CLEAR_INFORMATIONS';

export namespace Action {
  export enum Type {
    FETCH_INFORMATIONS = 'FETCH_INFORMATIONS',
    FETCH_INFORMATIONS_SUCCESS = 'FETCH_INFORMATIONS_SUCCESS',
    SET_TRIP_STATUS = 'SET_TRIP_STATUS',
    CLEAR_INFORMATIONS = 'CLEAR_INFORMATIONS',
  }

  export interface FetchInformationsSuccess extends ReduxAction<Type.FETCH_INFORMATIONS_SUCCESS> {
    prefix: 'start' | 'end';
    results: Array<object>;
  }

  export interface SetTripStatus extends ReduxAction<Type.SET_TRIP_STATUS> {
    prefix: 'start' | 'end';
    status: TripStatus;
  }

  export interface ClearInformations extends ReduxAction<Type.CLEAR_INFORMATIONS> {
    prefix: 'start' | 'end';
  }
}

export type Action<T extends Action.Type = Action.Type> = ValidateActionMap<{
  [Action.Type.FETCH_INFORMATIONS]: ReduxAction<Action.Type.FETCH_INFORMATIONS>;
  [Action.Type.FETCH_INFORMATIONS_SUCCESS]: Action.FetchInformationsSuccess;
  [Action.Type.SET_TRIP_STATUS]: Action.SetTripStatus;
  [Action.Type.CLEAR_INFORMATIONS]: Action.ClearInformations;
}>[T];

const fetchSuccess = (
  prefix: 'start' | 'end',
  results: Array<BVScheduledTransport>,
): Action<Action.Type.FETCH_INFORMATIONS_SUCCESS> => ({
  type: Action.Type.FETCH_INFORMATIONS_SUCCESS,
  prefix,
  results,
});

export const fetchTripInfos =
  (prefix: 'start' | 'end', site: string | number, date: string, tripNumber: string, signal?: AbortSignal) =>
  (dispatch: Dispatch) => {
    dispatch({
      type: Action.Type.FETCH_INFORMATIONS,
      prefix,
      tripNumber,
    });

    const uriPrefix = prefix === 'start' ? 'departure' : 'arrival';

    if (tripNumber && date && site) {
      API.getTripInfos(uriPrefix, site, date, tripNumber, signal)
        .then(results => dispatch(fetchSuccess(prefix, [results])))
        .catch(err => {
          if (err.name !== 'AbortError') dispatch(fetchSuccess(prefix, []));
        });
    }
  };

export const setTripStatus = (prefix: 'start' | 'end', status: TripStatus): Action<Action.Type.SET_TRIP_STATUS> => ({
  type: Action.Type.SET_TRIP_STATUS,
  prefix,
  status,
});

export const clearTripInfos = (prefix: 'start' | 'end'): Action<Action.Type.CLEAR_INFORMATIONS> => ({
  type: Action.Type.CLEAR_INFORMATIONS,
  prefix,
});
